module.exports = __webpack_public_path__ + "img/goods3_1.1b8c7359.jpg";